import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";

export const Error = () => {
    const { state } = useLocation();
    const { title, msg } = state || {};
    const defaultTitle = title ? title : "error.noContent";
    const defaultMsg = msg ? msg : "error.noUser.info";

    return (
      <div className="error-page">

        <h1><FormattedMessage id={defaultTitle}/></h1>
        <p className="info"><i className="fa fa-info-circle me-2"></i>
            <FormattedMessage id={defaultMsg}/>
        </p>
      </div>
    );
};